import PreviewQuestion from "pages/PreviewPage/PreviewQuestion/PreviewQuestion";

export default PreviewQuestion;
